export const entityTypes = [
  'order',
  'user',
  'organisation',
  'product',
  'category',
];
